import { render, staticRenderFns } from "./EditCompanyProfile.vue?vue&type=template&id=1456ece6&scoped=true&"
import script from "./EditCompanyProfile.vue?vue&type=script&lang=js&"
export * from "./EditCompanyProfile.vue?vue&type=script&lang=js&"
import style0 from "./EditCompanyProfile.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EditCompanyProfile.vue?vue&type=style&index=1&id=1456ece6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1456ece6",
  null
  
)

export default component.exports